import { useDispatch } from "react-redux";
import { mascaraMoeda, maskCurrency, TypePayment } from "../../../../utils/utils";
import { useContext, useEffect, useState } from "react";
import { Toast } from "../../../../utils/Toast";
import { UPDATE_SELECT_ORDER } from "../../../../stores/reducers/OrderReducers";
import { v4 } from "uuid";
import { OrderContext } from "../../../../context/OrderContext";
import { GlobalContext } from "../../../../context/GlobalContext";
import { api } from "../../../../api/api";

import { LuReceipt } from "react-icons/lu";
import { CustomItemCard } from "../../../CustomItemCard";
import { FaRegTrashCan } from "react-icons/fa6";

export function Payments({ order, inputRef }) {
  const { isAccess } = useContext(GlobalContext)
  const [cards, setCards] = useState([])
  const dispatch = useDispatch()
  const { updated } = useContext(OrderContext)

  const [state, setState] = useState({
    id: v4(),
    type: TypePayment.money,
    idCard: null,
    pricing: 0,
    pricingPayment: 0,
    pricingChange: 0,
  })

  function onChange(key, value) {
    setState({
      ...state,
      [key]: value
    })
  }

  let valuePricing = order?.payments?.reduce((prev, current) => prev + current.pricing, 0)
  let pricingRestante = order.total - valuePricing

  useEffect(() => {
    setState({
      ...state,
      pricing: valuePricing > 0 ? (order.total - valuePricing) : order.total
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order?.total, valuePricing])

  useEffect(() => {
    if (cards.length === 0) {
      api.get('/cards').then((res) => {
        setCards(res.data.data)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className="order-payments-list">
        <div className="row mt-3 div-payment" id="div-payment">
          <div className="col-sm-12 col-lg-12">
            <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '10px', marginBottom: '1.4rem' }}>
              <div style={{ width: '31px', height: '31px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#ff620025', borderRadius: 10 }}>
                <LuReceipt size={15} color="#ff6200" />
              </div>

              <p className="text-gray" style={{ fontSize: 'var(--font-size-section-title)', fontWeight: '600' }}>Pagamentos</p>
            </div>

            <div style={{ display: 'flex', gap: '1rem' }}>
              <div style={{ flex: 1, minWidth: '150px' }}>
                <label className="text-gray" style={{ marginBottom: '0.5rem', fontWeight: 500 }}>Forma de pagamento</label>

                <select style={{ height: '30px', borderRadius: 8 }} ref={inputRef} value={state.type} onChange={(e) => onChange('type', e.target.value)} className="form-select form-select-sm" aria-label=".form-select-sm example">
                  <option value={TypePayment.money}>Dinheiro</option>
                  <option value={TypePayment.card_credit}>Cartão Crédito</option>
                  <option value={TypePayment.card_debit}>Cartão Débito</option>
                  <option value={TypePayment.pix}>Pix</option>
                </select>
              </div>

              {(state.type === TypePayment.card_credit || state.type === TypePayment.card_debit) && (
                <div style={{ flex: 1 }}>
                  <label className="text-gray" style={{ marginBottom: '0.5rem', fontWeight: 500 }}>Bandeira</label>

                  <select style={{ height: '30px', borderRadius: 8 }} value={state.idCard} onChange={(e) => onChange('idCard', e.target.value)} className="form-select form-select-sm" aria-label=".form-select-sm example">
                    <option value={0}>Selecione</option>
                    {cards.map((card) => {
                      return (
                        <option key={card.id} value={card.id}>{card.name}</option>
                      )
                    })}
                  </select>
                </div>
              )}

              <div style={{ flex: 1 }}>
                <label className="text-gray" style={{ marginBottom: '0.5rem', fontWeight: 500 }}>Valor</label>

                <input style={{ height: '30px', borderRadius: 8 }} type="text" onChange={(e) => onChange('pricing', mascaraMoeda(e.target.value))} value={maskCurrency(state.pricing)} className="form-control form-control-sm" name="" id="" />
              </div>

              {state.type === TypePayment.money && (
                <>
                  <div style={{ flex: 1 }}>
                    <label className="text-gray" style={{ marginBottom: '0.5rem', fontWeight: 500 }} htmlFor="">Pago</label>
                    <input style={{ height: '30px', borderRadius: 8 }} type="text" id='paymentPricing' onChange={(e) => onChange('pricingPayment', mascaraMoeda(e.target.value))} value={maskCurrency(state.pricingPayment)} className="form-control form-control-sm" name="" />
                  </div>

                  <div style={{ flex: 1 }}>
                    <label className="text-gray" style={{ marginBottom: '0.5rem', fontWeight: 500 }} htmlFor="">Troco</label>

                    <input style={{ height: '30px', borderRadius: 8 }} type="text" id='pricingPayment' disabled onChange={(e) => onChange('pricingChange', mascaraMoeda(e.target.value))} value={maskCurrency(state.pricingPayment <= 0 ? 0 : state.pricingPayment - state.pricing)} className="form-control form-control-sm" name="" />
                  </div>
                </>
              )}
            </div>

            <div style={{ width: '100%', marginBottom: '2rem' }}>
              <button style={{ width: '100%', height: '3rem', fontSize: 'var(--font-size-button)', borderRadius: 8 }} className="mt-4 btn btn-sm btn-success" onClick={async () => {
                if (!isAccess('pedidos', 'update')) {
                  return Toast.warning('Você não tem permissão para atualizar pedido')
                }

                if (state.pricing > order.total) {
                  return Toast.warning('O valor pago não pode ser maior que o total')
                }

                const data = { ...state, id: v4(), pricingChange: state.type !== TypePayment.money ? 0 : state.pricingPayment - state.pricing }

                if ((data.type === TypePayment.card_credit || data.state === TypePayment.card_debit) && !data.idCard) {
                  return Toast.warning('Selecione por favor a bandeira do cartão')
                }

                const orderUpdated = { payments: [...(order?.payments ?? []), data] }

                if (order.total <= 0) {
                  return Toast.warning('O pedido está com valor zerado')
                }

                if (pricingRestante <= 0) {
                  return Toast.warning('O valor total já foi pago')
                }

                valuePricing = order.total - orderUpdated.payments.reduce((prev, current) => prev + current.pricing, 0)

                await updated(order.id, 'payments', orderUpdated.payments, false, true)

                dispatch(UPDATE_SELECT_ORDER({
                  ...orderUpdated,
                  id: order.id
                }))

                setState({
                  id: v4(),
                  type: TypePayment.money,
                  idCard: null,
                  pricing: valuePricing,
                  pricingChange: 0,
                  pricingPayment: 0,
                })
              }}>Adicionar</button>
            </div>


            {order?.payments?.map(payment => {
              return (
                <CustomItemCard
                  key={payment.id}
                  titleWeight="500"
                  maxWidth='auto'
                  minWidth='auto'
                  margin="1.3rem 0 0 0"
                  borderRadius='10px'
                  width="100%"
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="space-between"
                  backgroundColor="rgb(236 240 243 / 53%)"
                  initIcon={<FaRegTrashCan />}
                  onConfirm={async () => {
                    const orderUpdated = { payments: order?.payments?.filter(e => e.id !== payment.id) }
                    await updated(order.id, 'payments', orderUpdated.payments, false, true)

                    dispatch(UPDATE_SELECT_ORDER(orderUpdated))
                  }}
                >

                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div style={{ backgroundColor: '#1e9a601e', padding: '0.2rem 0.8rem', borderRadius: '10px' }}>
                      <p style={{ color: "#1e9a60", fontWeight: 600 }}>{payment.type}</p>
                    </div>

                    <p style={{ color: "black", fontWeight: 600, fontSize: 'var(--font-size-highlight)' }}>{maskCurrency(payment.pricing || 0)}</p>
                  </div>
                </CustomItemCard>
              )
            })}

            <div style={{ borderRadius: 10, backgroundColor: 'rgb(236 240 243 / 53%)', boxShadow: 'rgb(231 231 231) 0px 0px 0px 1px', padding: '1.4rem', margin: '2rem 0' }}>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.8rem' }}>
                <p style={{ fontSize: 'var(--font-size-highlight)', color: "#171717", fontWeight: 600 }}>Restante:</p>
                <p style={{ fontSize: 'var(--font-size-highlight)', color: "#171717", fontWeight: 600 }}>{maskCurrency(pricingRestante)}</p>
              </div>

              <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <p style={{ fontSize: 'var(--font-size-highlight)', color: "#171717", fontWeight: 600 }}>Total:</p>
                <p style={{ fontSize: 'var(--font-size-highlight)', color: "#ff6200", fontWeight: 600 }}>{maskCurrency(order.total)}</p>
              </div>
              {/* {!['cancelado', 'finalizado'].includes(order.status) && (
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
                      <button style={{ float: 'left' }} className="mt-3 btn btn-outline-primary" onClick={() => closeOrCancelOrder()}>Lançar e finalizar pedido</button>
                    </div>
                  )} */}
            </div>
          </div>
        </div>

      </div>
    </>
  )
}
